import type { ReactNode } from 'react';
import { Text } from '@ksyos/design-system';

export function Step({ children }: { children: ReactNode }) {
    return (
        <Text
            color="secondary"
            mb={2}
            size="md"
        >
            {children}
        </Text>
    );
}
